export type BorderColorClassKey = 'primary' | 'secondary' | 'tertiary';

export const useTWBorderColorClass = (
  color: BorderColorClassKey = 'tertiary',
): Ref<string> => {
  if (color === 'primary') {
    return ref('border-border-primary');
  } else if (color === 'secondary') {
    return ref('border-border-secondary');
  } else {
    return ref('border-border-tertiary');
  }
};
